import React from 'react'
import './Loader.css'

const Loader = () => {
    return (
        <div className="loaderWrapper">
            <img src="/assets/loading.gif" />
        </div>
    )
}

export default Loader
